<template>
  <div>
    <Alert show-icon v-if="show">
      未选择租户
      <Icon type="ios-bulb-outline" slot="icon"></Icon>
      <span slot="desc">
        请选择一个你要浏览和操作的私有云租户
      </span>
    </Alert>
  </div>
</template>

<script>
export default {
  name: 'not-project',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
